//list of restaurants
const sample_burgers = {
    burger1: {
        name: 'The Impossible Burger',
        price: 160.50,
        status: 'available',
        descr: 'impossible patty, american cheese, pickles, onion, mustard, ketchup. \r\n Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore verit. \r\n Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore verit',
        image: './images/burger1.jpg',
    },
    burger2: {
        name: 'The Original',
        price: 180.00,
        status: 'out_of_stock',
        descr: 'american cheese, pickles, onion, mustard, ketchup',
        image: './images/burger2.jpg',
    },
    burger3: {
        name: 'The Cheesy Chili',
        price: 150.50,
        status: 'available',
        descr: 'homemade chili, melted cheese, BBQ ranch, caramelized onions.\r\n Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore verit',
        image: './images/burger3.jpg',
    },
    burger4: {
        name: 'The Classic',
        price: 130.50,
        status: 'out_of_stock',
        descr: 'american cheese, pickles, lettuce, tomato, caramelized onions, Burger Shop secret dressing',
        image: './images/burger4.jpg',
    },
    burger5: {
        name: 'Wine Maker',
        price: 220.50,
        status: 'available',
        descr: 'saint agur blue cheese cream, grilled grapes, white cheddar, and port wine glaze',
        image: './images/burger5.jpg',
    },
    burger6: {
        name: 'The 3pm',
        price: 200.00,
        status: 'available',
        descr: 'bacon, crispy onion ring, american cheese, and bbq sauce',
        image: './images/burger6.jpg',
    },
    burger7: {
        name: 'Toro Bravo',
        price: 140.50,
        status: 'available',
        descr: 'roasted hatch chilies, candied bacon, white cheddar, and habanero aioli',
        image: './images/burger7.jpg',
    },
    burger8: {
        name: 'Loaded Grill Cheese',
        price: 250.00,
        status: 'available',
        descr: 'caramelized onions, tomatoes, pickles, avocado, white cheddar and cheese sauce',
        image: './images/burger4.jpg',
    },
}

export default sample_burgers;